import { render } from "./HelpDialogWorkflowAiVersion.vue?vue&type=template&id=03820678"
import script from "./HelpDialogWorkflowAiVersion.vue?vue&type=script&lang=js"
export * from "./HelpDialogWorkflowAiVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__